import { createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["order-id"];
const _hoisted_2 = { class: "td__today-number" };
const _hoisted_3 = { class: "td__hub-name" };
const _hoisted_4 = { class: "td__allocated-hub-name" };
const _hoisted_5 = { class: "td__store-name" };
const _hoisted_6 = { class: "td__worker-name" };
const _hoisted_7 = { class: "td__allocated-worker-phone" };
const _hoisted_8 = { class: "td__store-phone" };
const _hoisted_9 = { class: "td__receiver-phone" };
const _hoisted_10 = { class: "td__drop-address" };
const _hoisted_11 = { class: "td__memo" };
const _hoisted_12 = { class: "td__status-code" };
const _hoisted_13 = { class: "td__ordered-at" };
const _hoisted_14 = { class: "td__finished-at" };
const _hoisted_15 = { class: "td__canceled-at" };
const _hoisted_16 = { class: "td__store-memo" };
const _hoisted_17 = { class: "td__pickup-address" };
const _hoisted_18 = { class: "td__purchase-delivery-charge" };
const _hoisted_19 = { class: "td__order-amount" };
const _hoisted_20 = { class: "td__delivery-pay-type" };
const _hoisted_21 = { class: "td__order-id" };
const _hoisted_22 = { class: "td__delivery-distance" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PayType = _resolveComponent("PayType");
    const _component_Chip = _resolveComponent("Chip");
    return (_openBlock(), _createElementBlock("tr", {
        "data-cy": "delivery-history-row",
        "order-id": _ctx.order.orderId,
        class: _normalizeClass(_ctx.isCanceledRow),
        onDblclick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.handleDbClickRow && _ctx.handleDbClickRow(...args)))
    }, [
        _createCommentVNode(" 공유건 여부 "),
        _createElementVNode("td", {
            class: _normalizeClass(_ctx.isShare)
        }, null, 2 /* CLASS */),
        _createCommentVNode(" 당일순번 "),
        _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.order.todayNumber), 1 /* TEXT */),
        _createCommentVNode(" 발주허브 "),
        _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.order.hubNameWithHypen()), 1 /* TEXT */),
        _createCommentVNode(" 수행허브 "),
        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.validateTextWithHypen(_ctx.order.allocatedHubName)), 1 /* TEXT */),
        _createCommentVNode(" 상점명 "),
        _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.order.storeName), 1 /* TEXT */),
        _createCommentVNode(" 담당 라이더 "),
        _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.order.workerName), 1 /* TEXT */),
        _createCommentVNode(" 라이더 전화번호 "),
        _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.order.allocatedWorkerPhone), 1 /* TEXT */),
        _createCommentVNode(" 상점 전화번호 "),
        _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.order.storePhone), 1 /* TEXT */),
        _createCommentVNode(" 고객 전화번호 "),
        _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.order.customerSafePhone), 1 /* TEXT */),
        _createCommentVNode(" 도착지 주소 "),
        _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.order.dropAddressForPrivacy()), 1 /* TEXT */),
        _createCommentVNode(" 메모 "),
        _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.order.memo), 1 /* TEXT */),
        _createCommentVNode(" 주의사항 "),
        _createElementVNode("td", {
            class: _normalizeClass(["td__order-caution", _ctx.order.orderCaution.textColor])
        }, _toDisplayString(_ctx.orderCaution), 3 /* TEXT, CLASS */),
        _createCommentVNode(" 상태 "),
        _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.order.translatedStatus), 1 /* TEXT */),
        _createCommentVNode(" 접수시간 "),
        _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.validateTextWithHypen(_ctx.formatDate(_ctx.order.orderedAt, _ctx.dateFormatType.FULL_DATE))), 1 /* TEXT */),
        _createCommentVNode(" 완료시간 "),
        _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.validateTextWithHypen(_ctx.formatDate(_ctx.order.finishedAt, _ctx.dateFormatType.FULL_DATE))), 1 /* TEXT */),
        _createCommentVNode(" 취소시간 "),
        _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.validateTextWithHypen(_ctx.formatDate(_ctx.order.canceledAt, _ctx.dateFormatType.FULL_DATE))), 1 /* TEXT */),
        _createCommentVNode(" 출발지 메모 "),
        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.order.storeMemo), 1 /* TEXT */),
        _createCommentVNode(" 출발지 주소 "),
        _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.order.getPickupFullAddress()), 1 /* TEXT */),
        _createCommentVNode(" 대행료 "),
        _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.order.totalDeliveryFee), 1 /* TEXT */),
        _createCommentVNode(" 결제금액 "),
        _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.order.orderAmountForClient), 1 /* TEXT */),
        _createCommentVNode(" 결제방법 "),
        _createElementVNode("td", null, [
            _createVNode(_component_PayType, {
                "is-full-text": "",
                "pay-types": _ctx.payTypes
            }, null, 8 /* PROPS */, ["pay-types"])
        ]),
        _createCommentVNode(" 수행허브명 "),
        _createCommentVNode(" 라이더에게 지불방식 "),
        _createElementVNode("td", _hoisted_20, [
            _createVNode(_component_Chip, {
                text: _ctx.order.deliveryPayTypeForClient,
                "brg-chip-color": _ctx.brgChipColorMapper.blue
            }, null, 8 /* PROPS */, ["text", "brg-chip-color"])
        ]),
        _createCommentVNode(" 배달번호 "),
        _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.order.orderId), 1 /* TEXT */),
        _createCommentVNode(" 운행거리 "),
        _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.order.deliveryDistance), 1 /* TEXT */)
    ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1));
}
